import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useGetAllStaffQuery, useDeleteUserMutation } from "../../services/userCRUDApi";
import { Add, BadgeOutlined } from "@mui/icons-material";
import {
  AdminPageHeader,
  AdminToolbar,
  AdminTable,
  AdminBadge,
  AdminButton,
  AdminRowActions,
  useConfirm,
  useToast,
} from "../../components/ui";

function Staff() {
  const { data, isLoading } = useGetAllStaffQuery();
  const [deleteUser] = useDeleteUserMutation();
  const navigate = useNavigate();
  const confirm = useConfirm();
  const toast = useToast();
  const [search, setSearch] = useState("");

  const allRows = data?.results ?? [];
  const term = search.trim().toLowerCase();
  const rows = term
    ? allRows.filter(
        (s) =>
          `${s.first_Name} ${s.last_Name}`.toLowerCase().includes(term) ||
          (s.email || "").toLowerCase().includes(term)
      )
    : allRows;

  const handleDelete = async (member) => {
    const ok = await confirm({
      title: "Delete staff member",
      message: `Delete ${member.first_Name} ${member.last_Name}? This can't be undone.`,
      confirmLabel: "Delete",
      danger: true,
    });
    if (!ok) return;
    const res = await deleteUser(member.id);
    if (res.error) toast.error("Could not delete this staff member.");
    else toast.success("Staff member deleted.");
  };

  const columns = [
    { key: "type", header: "Role", render: (s) => <AdminBadge variant="purple">{s.type}</AdminBadge> },
    { key: "id", header: "ID", width: 70 },
    { key: "name", header: "Name", render: (s) => `${s.first_Name} ${s.last_Name}` },
    { key: "email", header: "Email" },
    { key: "phone_Number", header: "Phone" },
    {
      key: "actions",
      header: "",
      align: "right",
      render: (s) => (
        <AdminRowActions
          label={`${s.first_Name} ${s.last_Name}`}
          onEdit={() => navigate(`/admin/customer/edit/${s.id}`)}
          onDelete={() => handleDelete(s)}
        />
      ),
    },
  ];

  return (
    <div>
      <AdminPageHeader
        title="Staff"
        subtitle="Manage staff and admin accounts."
        breadcrumbs={[{ label: "Dashboard", to: "/admin/dashboard" }, { label: "Staff" }]}
        primaryAction={
          <Link to="/admin/newstaff">
            <AdminButton icon={<Add />}>Create User</AdminButton>
          </Link>
        }
      />
      <AdminToolbar searchValue={search} onSearchChange={setSearch} searchPlaceholder="Search staff by name or email..." />
      <AdminTable
        columns={columns}
        rows={rows}
        rowKey={(s) => s.id}
        isLoading={isLoading}
        emptyIcon={<BadgeOutlined />}
        emptyTitle={search ? "No staff match your search" : "No staff members yet"}
        pageSize={10}
      />
    </div>
  );
}

export default Staff;
